import React from "react";
import { useListCountriesQuery } from "features/counteris/countriesApi";
import { Autocomplete, TextField } from "@mui/material";

type Props = {
  name: string;
  value: string;
  label: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur: (e: React.FocusEvent) => void;
  error?: string;
  disabled?: boolean;
  size?: "small" | "medium";
  kycProgramId?: number | null;
};
const CountryAutocomplete: React.FC<Props> = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  size,
  label,
  kycProgramId,
}) => {
  const { data, isLoading } = useListCountriesQuery(
    { kycProgramId: kycProgramId! },
    { skip: !kycProgramId }
  );
  return (
    <Autocomplete
      options={data?.countries.map(({ value }) => value) || []}
      value={value || null}
      disabled={isLoading || disabled}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          name={name}
          variant="outlined"
          fullWidth
          onBlur={onBlur}
          error={!!error}
          helperText={error}
        />
      )}
      onChange={(...args) => {
        onChange({
          ...args[0],
          target: {
            name,
            value: args[1] || "",
          },
        });
      }}
    />
  );
};

export default CountryAutocomplete;
